import CategoryPage from './CategoryPage';

const MangueirasPage = () => <CategoryPage category="mangueiras" />;

export default MangueirasPage;
